import { render, staticRenderFns } from "./ReserveTypeSelectInputWidget.vue?vue&type=template&id=5303110a&scoped=true"
import script from "./ReserveTypeSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./ReserveTypeSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5303110a",
  null
  
)

export default component.exports